
import { DatePipe, } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  Component,
  OnInit,

} from '@angular/core';


import { ActivatedRoute, Router } from '@angular/router';
import { AllInOneService } from 'src/app/shared/services/all-in-one.service';
import { KunyekService } from 'src/app/shared/services/kunyek.service';
import { MessageService } from 'src/app/shared/services/message.service';
import { MatDialog } from '@angular/material/dialog';
import { RequestUserListComponent } from '../request-user-list/request-user-list.component';
import { Sort } from '@angular/material/sort';
import { FilterPipe } from 'src/app/shared/filter.pipe';

@Component({
  selector: 'app-pickup-point',
  templateUrl: './pickup-point.component.html',
  styleUrls: ['./pickup-point.component.scss']
})
export class PickupPointComponent implements OnInit {


  gettingData: boolean = false;
  pickupList: any = [];
  addpickup: boolean = false;
  saveLoading: boolean = false;
  gettingVehicle: boolean = false;
  pickupFormSave: boolean = false;
  isEditing: boolean = false;
  orgid: any = "";
  organizations: any = [];
  searchText: any = "";

  itemPerPage: any = "";
  currentPage: any = 1;
  text1: any = "";
  text2: any = "";

  pg = [
    {
      name: '100 items',
      count: 100,
    },
    {
      name: '300 items',
      count: 300,
    },
    {
      name: '500 items',
      count: 500,
    },
  ];

  pickupForm = {
    "name": "",
    "description": "",
    "user": [],
    "pickupid": ""
  }
  passengerList: any = [];
  orgPassengerList: any = [];
  requsetidList: any = [];
  delerequest: any = [];
  useridlist: any = [];
  istransoprationAdmin: boolean = false;
  constructor(
    public allinoneService: AllInOneService,
    private http: HttpClient,
    private messageService: MessageService,
    private kunyekService: KunyekService,
    private activatedRoute: ActivatedRoute,
    public datepipe: DatePipe,
    private dialog: MatDialog,
    private router: Router,
    private filter:FilterPipe
  ) {
    this.istransoprationAdmin = this.allinoneService.isAdminOf("transportation");
    if (this.istransoprationAdmin == false) {
      this.router.navigateByUrl(`transportation`);
    }
    this.organizations = this.allinoneService.tranOrgs;
    this.orgid = this.allinoneService.selectedTranOrg
      ? this.allinoneService.selectedTranOrg
      : this.organizations[0].orgid;
  }

  ngOnInit(): void {
    this.getPickupPoint();
  }


  new() {
    this.addpickup = true;
    this.pickupForm.name = "";
    this.pickupForm.description = "";
    this.pickupForm.user = [];
    this.pickupFormSave = false;
    this.pickupForm.pickupid = "";
    this.useridlist = [];
    this.passengerList = [];

  }

  cancelFunction() {
    this.addpickup = false;
    this.isEditing = false;
  }
  submitPickForm() {
    this.pickupFormSave = true;

    if (this.pickupForm.name == "") {
      return;
    } else {
      this.saveLoading = true;
      this.useridlist = [];
      this.requsetidList = [];
      if (this.passengerList.length > 0) {
        for (let i = 0; i < this.passengerList.length; i++) {
          this.requsetidList.push(this.passengerList[i]['requestid']);
          if (this.passengerList[i]['trantype'] == '002') {
            for (let j = 0; j < this.passengerList[i]['userlist'].length; j++) {
              this.useridlist.push(this.passengerList[i]['userlist'][j]);
            }
            this.useridlist.push(this.passengerList[i]['userid']);
          } else {
            this.useridlist.push(this.passengerList[i]['userid']);
          }
        }
      }

      var uniqueArray = Array.from(new Set(this.useridlist));

      var data = {
        "orgid": this.orgid,
        "domainid": this.allinoneService.getDomain().domainid,
        "name": this.pickupForm.name,
        "useridlist": uniqueArray,
        "requestdata": this.passengerList,
        "requestidlist": this.requsetidList,
        "removerequestidlsit": this.delerequest,
        "type" : "001"
      }
      console.log(data);

      if (this.isEditing) {
        data = Object.assign(data,
          {
            "pickuppointid": this.pickupForm.pickupid,
          }
        );
      }
      console.log(data);
      if (this.isEditing) {
        this.kunyekService.updatePickup(data).subscribe(
          (res: any) => {

            if (res.returncode == '300') {
              this.addpickup = false;
              this.pickupFormSave = false;
              this.saveLoading = false;
              this.isEditing = false;
              this.getPickupPoint();
            } else {
              this.saveLoading = false;
              this.messageService.openSnackBar(res.message, 'warn');
            }
          },
          (err) => {
            this.saveLoading = false;
          }
        );
      } else {
        this.kunyekService.addPickup(data).subscribe(
          (res: any) => {

            if (res.returncode == '300') {
              this.addpickup = false;
              this.isEditing = false;
              this.pickupFormSave = false;
              this.saveLoading = false;
              this.getPickupPoint();
            } else {
              this.saveLoading = false;
              this.messageService.openSnackBar(res.message, 'warn');
            }
          },
          (err) => {
            this.saveLoading = false;
          }
        );
      }

    }

  }


  getPickupPoint() {
    this.gettingData = true;
    this.pickupList = [];

    var data = {
      domainid: this.allinoneService.getDomain().domainid,
      orgid: this.orgid,
      "type" : '001',
    };
    this.kunyekService.getPickup(data).subscribe(
      (res: any) => {

        if (res.returncode == '300') {
          res.datalist.map((item: any) => {
            this.pickupList.push({
              "name": item.name,
              "user": "",
              "userid": item.userid,
              "requestdata": item.requestdata,
              "usercounts": item.usercounts,
              "pickuppointid": item.pickuppointid,
            })
          });

          this.gettingData = false;
        } else {

          this.gettingData = false;
          this.messageService.openSnackBar(res.message, 'warn');
        }
      },
      (err) => {
        this.messageService.openSnackBar(err, 'warn');
        this.gettingData = false;
      }
    );
  }




  async pickupedit(data: any) {
    this.isEditing = true;
    this.pickupForm.name = data.name;
    this.pickupForm.description = data.description;
    this.pickupForm.user = [];
    this.delerequest = [];
    this.pickupForm.pickupid = data.pickuppointid;
    this.passengerList = JSON.parse(JSON.stringify(data.requestdata));
    this.orgPassengerList = JSON.parse(JSON.stringify(data.requestdata));


  }

  refreshgetData() {
    this.getPickupPoint();
  }


  changePageCount(event: any) {
    console.log(this.itemPerPage)
    this.itemPerPage = event.target.value;
    console.log(this.itemPerPage)
    this.currentPage = 1;
    this.refreshgetData();
  }

  choosePassenger() {
    const dialog = this.dialog.open(RequestUserListComponent, {
      height: '550px',
      width: '500px',
      closeOnNavigation: true,
      panelClass: ['user-profile-modal', 'mat-typography'],
      data: {
        orgid: this.orgid,
        domainid: this.allinoneService.getDomain().domainid,
        passengerList: this.passengerList,
      },
      // scrollStrategy: new NoopScrollStrategy(),
    });
    dialog.afterClosed().subscribe((dialogResult: any) => {
      if (dialogResult) {
        console.log(dialogResult);
        if (dialogResult) {
          this.passengerList = dialogResult.data;
          console.log(this.passengerList);
        }
      }
    });
  }

  delete(index: any) {
    for (let i = 0; i < this.orgPassengerList.length; i++) {
      if (this.orgPassengerList[i]['requestid'] == this.passengerList[index]['requestid']) {
        this.delerequest.push(this.orgPassengerList[i]['requestid'])
      }

    }

    console.log(this.delerequest);

    this.passengerList.splice(index, 1);





  }


  
  sortData(sort: Sort) {
    const data = this.pickupList;
    if (!sort.active || sort.direction === '') {
      this.pickupList = data;
    }

    this.pickupList = data.sort((a: any, b: any) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'name':
          return this.allinoneService.compare(
            a.name.toLocaleLowerCase(),
            b.name.toLocaleLowerCase(),
            isAsc
          );
        case 'usercounts':
          return this.allinoneService.compare(
            parseInt(a.usercounts),
            parseInt(b.usercounts),
            isAsc
          );
        default:
          return 0;
      }

    });

  }

  downloadSheet() {
    var pickupExport = this.filter.transform(
      this.pickupList,
      this.searchText,
      "pickup"
    );


    var data: any = [];
    var date = new Date();
    var time = this.datepipe.transform(date, 'yyyy/MM/dd');
    var name = 'Pickup_Point' + time + '.xlsx';
    pickupExport.map((pick: any) => {
      data.push({
        "Name": pick.name,
        // "Passenger": pick.usercounts,
      });
    });

    this.allinoneService.exportEcecl(data, name);

  }

}
